"use client";

import { getLetterStatuses } from "@/lib/daily/scoreCalculator";

interface FinWordGridProps {
  readonly guesses: readonly string[];
  readonly currentGuess: string;
  readonly solution: string;
  readonly isSubmitted: boolean;
  readonly shakeRowIndex?: number | null;
}

export default function FinWordGrid({
  guesses,
  currentGuess,
  solution,
  isSubmitted,
  shakeRowIndex,
}: FinWordGridProps) {
  const rows = Array.from({ length: 6 });

  return (
    <div className="finword-grid" role="grid" aria-label="FinWord Guesses Grid">
      {rows.map((_, i) => {
        const isSubmittedRow = i < guesses.length;
        const isActiveRow = i === guesses.length && !isSubmitted;
        const isShake = shakeRowIndex === i;

        let rowClass = "finword-row";
        if (isSubmittedRow) rowClass += " submitted";
        if (isShake) rowClass += " invalid";

        return (
          <div key={i} className={rowClass} role="row" aria-label={`Row ${i + 1}`}>
            {Array.from({ length: 5 }).map((_, j) => {
              let letter = "";
              let cellClass = "finword-cell";

              if (isSubmittedRow) {
                const word = guesses[i];
                letter = word[j] || "";
                const statuses = getLetterStatuses(word, solution);
                cellClass += ` ${statuses[j]}`;
              } else if (isActiveRow) {
                letter = currentGuess[j] || "";
                if (letter) cellClass += " populated";
              }

              return (
                <div
                  key={j}
                  className={cellClass}
                  role="gridcell"
                  aria-label={
                    letter
                      ? `Column ${j + 1}: ${letter}`
                      : `Column ${j + 1}: Empty`
                  }
                >
                  {letter}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
